import { useContext } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { usersContext } from '../UsersContext';
import { FilterContainer, SearchButton } from 'components';


let Filters = () => {
    let service = useContext(usersContext);


    return (
        <FilterContainer onSubmit={() => service.doSearch()}>
            <Grid item xs={2}>
                <TextField
                    variant="outlined"
                    label="Email"
                    type="email"
                    value={service.emailSearch}
                    onChange={(e) => service.updateSearch(e.target.value)}
                />
            </Grid>

            <Grid item xs>
                <SearchButton type='submit' />
            </Grid>
        </FilterContainer>
    )
}

export default Filters;